import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { Route } from "./utils/routes";
import TopBar from "./components/template/base-template/top-bar";

const router = createBrowserRouter([
    {
        path: Route.Dashboard,
        element: (
            <>
                <TopBar />
                <App />
            </>
        ),
        errorElement: <h1>404 Not Found</h1>,
        children: [
            {
                path: Route.Dashboard,
                lazy: async () => {
                    const { default: Dashboard } = await import("./pages/dashboard");
                    return { Component: Dashboard };
                },
            },
            {
                path: Route.Opportunities,
                lazy: async () => {
                    const { default: Opportunities } = await import("./pages/opportunities");
                    return { Component: Opportunities };
                },
            },
            {
                path: Route.Ilians,
                lazy: async () => {
                    const { default: Ilians } = await import("./pages/ilians");
                    return { Component: Ilians };
                },
            },
            {
                path: Route.IliansDetails,
                lazy: async () => {
                    const { default: IlianDetails } = await import("./pages/ilians-detail");
                    return { Component: IlianDetails };
                },
            },
        ],
    },
]);

export default router;
